<template>
    <div class="liveEdit padding-20 bgc box-shadow">
        <!-- 创建直播 -->
        <div class="issueContent">
            <div class="liveForm">
                <el-form :model="liveData" :rules="rules" ref="liveData" label-width="110px" class="demo-item" label-position="left" size="mini">
                    <!--直播模式-->
                    <div class="classes blod">直播模式</div>
                    <el-form-item label="模式设置" prop="screenmode">
                        <div class="modeTips">主播推流后，不可修改直播模式</div>
                        <el-radio-group v-model="liveData.screenmode" :disabled="isStart">
                            <el-radio :label="2">竖屏直播<span class="tips magin20">适用于泛娱乐教学、营销带货类直播（该模式仅支持在小程序上发起直播）</span></el-radio>
                            <el-radio :label="1">横屏直播<span class="tips magin20">适用于需要演讲课件的知识讲解类直播</span></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <!--基本信息-->
                    <div class="classes blod">基本信息</div>
                    <el-form-item label="直播名称" prop="subject" class="liveName">
                        <el-input v-model.trim="liveData.subject" placeholder="输入直播名称（建议在14字以内，不超过32个字）" clearable maxlength="32" show-word-limit :disabled="isEnd"></el-input>
                    </el-form-item>
                    <el-form-item label="直播简介"class="liveName">
                        <el-input type="textarea" v-model.trim="liveData.description" placeholder="输入直播简介" clearable maxlength="100" show-word-limit :disabled="isEnd"></el-input>
                    </el-form-item>
                    <div class="liveform_flex">
                        <el-form-item label="直播时间" prop="begintime" placeholder="选择日期">
                            <el-date-picker v-model="liveData.begintime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" clearable :disabled="isStart"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="直播时长" label-width="70px">
                            <el-select v-model="liveData.livelength" placeholder="请选择" :disabled="isStart">
                                <el-option v-for="item in durationList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <el-form-item label="直播封面" prop="logoPic" class="upload-image">
                        <!--<upload class="headImage" :imgRule="imgRule" ref="logofile" @setImage="setLogourl" :uploadType="uploadType" v-if="!isEnd"></upload>-->
                        <!--<div class="upload headImage" v-else>-->
                            <!--<div class="avatar-uploader">-->
                                <!--<div tabindex="0" class="el-upload el-upload&#45;&#45;text" style="cursor: not-allowed;">-->
                                    <!--<img :src="liveData.logourl" class="avatar">-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <div class="upload headImage" @click="openLocalGallery">
                            <div class="avatar-uploader">
                                <div tabindex="0" class="el-upload el-upload--text">
                                    <i class="el-icon-plus avatar-uploader-icon icon_upload" v-if="!liveData.logourl"></i>
                                    <img :src="liveData.logourl" class="avatar" v-else>
                                </div>
                            </div>
                        </div>
                        <div class="el-upload__tip">
                            <el-button type="warning" @click="openSystemGallery" :disabled="isEnd">素材库</el-button>
                            <div>建议像素：750x422px或16:9，JPG、PNG格式，大小不超过5M。 </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="直播详情">
                        <div class="ueditorBox">
                            <uEditor :content="liveData.content" ref="uEditor" @getUEditorContent="getMsgContent" :disabled="isEnd"></uEditor>
                        </div>
                    </el-form-item>
                    <el-form-item label="主播设置" class="">
                        <div>
                            <el-button type="primary" plain @click="anchorAdd" :disabled="isEnd">+添加主播</el-button>
                            <span class="tips magin20">添加用户成为主播，您也可以在直播创建完成之后进行主播设置</span>
                        </div>
                        <!--主播table-->
                        <div v-if="liveData.headerlist.length>0">
                            <LiveHeadList ref="liveHeadList" :tableData="liveData.headerlist" :status="liveData.status"></LiveHeadList>
                        </div>
                    </el-form-item>
                    <el-form-item label="回放设置" class="liveName">
                        <el-switch v-model="liveData.isrecord"  :active-value=1 :inactive-value=0 :disabled="isStart"></el-switch>
                        <span class="tips magin20">开启回放后，直播结束后直播间将播放回放视频</span>
                    </el-form-item>
                    <!--付费设置-->
                    <div class="classes blod">付费设置</div>
                    <el-form-item label="付费方式">
                        <div class="paySet">
                            <el-radio-group v-model="liveData.feetype" :disabled="isEnd">
                                <el-radio :label="1">免费</el-radio>
                                <el-radio :label="2">付费</el-radio>
                                <el-radio :label="3">加密</el-radio>
                            </el-radio-group>
                            <!--付费-->
                            <div class="priceBox_wrap" v-show="liveData.feetype==2">
                                <el-form-item class="priceBox" prop="price" label-width="85px" label="商品价格">
                                    <el-input v-model.trim="liveData.saleprice" placeholder="请输入商品价格" :disabled="isEnd"></el-input>
                                    <span>元</span>
                                </el-form-item>
                                <el-form-item class="priceBox" label-width="85px" label="划线价格">
                                    <el-input v-model="liveData.uprice" placeholder="请输入划线价格" :disabled="isEnd"></el-input>
                                    <span>元</span>
                                </el-form-item>
                            </div>
                            <!--加密-->
                            <el-form-item class="priceBox" prop="livepass" label="设置密码" label-width="85px" v-show="liveData.feetype==3">
                                <el-input v-model.trim="liveData.livepass" placeholder="设置密码" :disabled="isEnd"></el-input>
                            </el-form-item>
                        </div>
                    </el-form-item>
                    <!--引流设置-->
                    <div class="classes blod">引流设置</div>
                    <el-form-item label="加粉设置">
                        <el-switch v-model="liveData.isopenfansguide" :active-value=1 :inactive-value=0  :disabled="isEnd"></el-switch>
                        <span class="tips magin20">开启后，在移动端可以出现加粉引导弹窗</span>
                    </el-form-item>
                    <div class="fansBox" v-show="liveData.isopenfansguide==1">
                        <el-form-item label="加粉引导名称">
                            <el-input v-model.trim="liveData.fansguidename" placeholder="请输入名称（最多10个字）" clearable maxlength="10" show-word-limit :disabled="isEnd"></el-input>
                        </el-form-item>
                        <el-form-item label="加粉引导文字">
                            <el-input type="textarea" v-model.trim="liveData.fansguidecontent" placeholder="请输入文字" clearable maxlength="40" show-word-limit :disabled="isEnd"></el-input>
                        </el-form-item>
                        <el-form-item label="引导二维码" class="flex_fans">
                            <upload class="fansImg" :imgRule="imgRule" ref="fansfile" @setImage="setLogoFile" :uploadType="uploadType" v-if="!isEnd"></upload>
                            <div class="fansImg" v-else>
                                <img :src="liveData.fansguideimgurl" alt="">
                            </div>
                            <div class="fans_tips">建议上传1:1尺寸，JPG、PNG格式，大小不超过5M。</div>
                        </el-form-item>
                    </div>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('liveData')" v-if="!isEnd">发布</el-button>
                        <el-button type="" @click="cancel">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <!--<scrollBox ref="coverScrollBox" :uploadType="uploadType" @saveMaterialFile="setMaterialCoverfile"></scrollBox>-->
        <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="editImage" :uploadType="uploadType"></localCropper>
        <systemCropper :cropperOption="cropperOption" ref="systemCropper" @setImage="editImage"  :uploadType="uploadType"></systemCropper>
        <AddAnchor ref="addAnchor" @getTable="_getTable"></AddAnchor>
        <CreatSuccess ref="creat"></CreatSuccess>
    </div >
</template>
<script>
    import {uploadLiveEventInfo,getLiveEventInfo} from 'api/vliveV2Api'
    import {mapGetters, mapActions} from 'vuex'
    import LocalCropper from 'base/cropper/localCropper'
    import SystemCropper from 'base/cropper/systemCropper'
    import Upload from 'base/upload/upload'
    import UEditor from 'base/uEditor/uEditor2'
    import ScrollBox from 'base/scrollBox/scrollBox'
    import PaySet from '@/views/vliveV2/components/paySet'
    import AddAnchor from '@/views/vliveV2/components/addAnchor'
    import LiveHeadList from '@/views/vliveV2/components/liveHeadList'
    import CreatSuccess from '@/views/vliveV2/components/creatSuccess'
    import {formatFileInfo} from 'common/js/tools'
    export default {
        name: 'LiveEdit',
        data() {
           return{
               fansCode:require('@/common/images/vliveV2/fansCode.png'),
               // isDisabled: false,
               cropperOption: {
                   fixedNumber: [1280, 720], // 截图框的宽高比例
                   enlarge: 4, // 图片根据截图框输出比例倍数
                   autoCropWidth: 320, // 默认生成截图框宽度
                   autoCropHeight: 180 // 默认生成截图框高度
               },
               uploadType: {
                   catecode: '95',
                   datatype: 'IMAGE'
               },
               durationList:[{
                   value: 60,
                   label: '1小时'
               },{
                   value: 90,
                   label: '1.5小时'
               },{
                   value: 120,
                   label: '2小时'
               },{
                   value: 150,
                   label: '2.5小时'
               },{
                   value: 180,
                   label: '3小时'
               },{
                   value: 1440,
                   label: '1天'
               },{
                   value: 2880,
                   label: '2天'
               },{
                   value: 0,
                   label: '永久'
               }],
               liveData:{
                   liveid:this.$route.query.liveid?this.$route.query.liveid:'', //直播id
                   screenmode:2, //直播模式
                   subject:'', //直播名称
                   description:'', //直播简介
                   begintime:'', //直播时间
                   livelength:120, //直播时长
                   logourl:'', //直播封面url
                   logoattrid:'', //直播封面id
                   content:'', //直播详情
                   headerlist:[], //主播列表
                   feetype: 1, //付费设置 1免费 2收费 3加密
                   saleprice:'', //销售价格
                   uprice:'', //划线价格
                   livepass:'', //加密密码
                   isrecord:false, //回放设置 0否 1是 默认关闭
                   isopenfansguide:false, //加粉设置 0否 1是 默认关闭
                   fansguidename:'', //加粉名称
                   fansguidecontent:'', //加粉文字
                   fansguideimgurl:'', //加粉图片url
               },
               isStart:false,
               isEnd:false,
               isLiving:false,
               logoPic: {
                   bucket: '',
                   fname: '',
                   fsize: '',
                   width: '',
                   height: '',
                   key: '',
                   mimeType: '',
                   objecttype: '',
                   furl: ''
               },
               fansPic: {
                   bucket: '',
                   fname: '',
                   fsize: '',
                   width: '',
                   height: '',
                   key: '',
                   mimeType: '',
                   objecttype: '',
                   furl: ''
               },
               rules:{
                   screenmode:[
                       {required: true, message: '请选择直播模式', trigger: 'change'},
                   ],
                   subject: [
                       {required: true, message: '请输入直播名称', trigger: 'blur'},
                   ],
                   logoPic: [
                       {required: true, message: '请选择直播封面', trigger: 'blur'},
                   ],
                   begintime: [
                       {required: true, message: '请选择直播时间', trigger: 'blur'},
                   ],
                   price: [
                       {required: '', message: '请输入商品价格', trigger: 'blur'}
                   ],
                   livepass:[
                       {required: '', message: '请输入密码', trigger: 'blur'}
                   ]
               },
               imgRule: {
                   cls: 'icon_upload',
                   accept: 'image/png,image/jpeg',
                   size: 5,
                   width: '',
                   height: ''
               },
               status:0,
           }
        },
        created() {
        },
        mounted() {
            //直播封面
            // this.$refs.logofile.setImage(this.logoPic.furl)
            //加粉头像
            this.$refs.fansfile.setImage(this.fansPic.furl)
            if(this.liveData.liveid){
                this.getInfo()
            }
            this.getTime()
        },
        methods: {
            //获取直播信息
            getInfo(){
                this.setLoading(true)
                let params={
                    liveid:this.$route.query.liveid?this.$route.query.liveid:''
                }
                getLiveEventInfo({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.liveData=data.data
                        this.$refs.uEditor.init(this.liveData.content)
                        this.status=data.data.status
                        this.isStart=[0].indexOf(data.data.status)<0
                        this.isEnd=[10,100].indexOf(data.data.status)>=0
                        this.isLiving=[1].indexOf(data.data.status)>=0
                        this.$nextTick(() => {
                            if (!this.isEnd) {
                                // this.$refs.logofile.setImage(this.liveData.logourl)
                                this.$refs.fansfile.setImage(this.liveData.fansguideimgurl)
                            }
                        })
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            //主播列表回调
            _getTable(list){
                let arr = this.liveData.headerlist.map(item=>{
                    return item.customerid
                })
                list.forEach(item=>{
                    if(!arr.includes(item.customerid)){
                        this.liveData.headerlist.push(item)
                    }
                })
            },
            //发布直播
            submitForm(){
                if(this.liveData.screenmode==''){
                    this.$message({
                        message: '请选择直播模式',
                        type: 'warning'
                    });
                    return
                }
                if(this.liveData.subject==''){
                    this.$message({
                        message: '请输入直播名称',
                        type: 'warning'
                    });
                    return
                }
                if(this.liveData.begintime==''){
                    this.$message({
                        message: '请选择直播时间',
                        type: 'warning'
                    });
                    return
                }
                if(this.liveData.logourl==''){
                    this.$message({
                        message: '请选择直播封面',
                        type: 'warning'
                    });
                    return
                }
                if(this.liveData.feetype==''){
                    this.$message({
                        message: '请选择付费方式',
                        type: 'warning'
                    });
                    return
                }if(this.liveData.feetype==2&&(this.liveData.uprice<this.liveData.saleprice)){
                    this.$message({
                        message: '划线价格不能低于商品价格',
                        type: 'warning'
                    });
                    return
                }else{
                    this.setLoading(true)
                    uploadLiveEventInfo({
                        data: Object.assign({}, this.liveData),
                        success: data => {
                            this.setLoading(false)
                            if(this.liveData.liveid){ //编辑
                                this.$message({
                                    type: 'success',
                                    message: '操作成功'
                                })
                                this.$router.push({name: 'LiveList'})
                            }else{ //创建
                                this.$refs.creat.open(data.data.shareurl,data.data.liveid);
                            }
                            console.log(this.liveData)
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                            console.log(this.liveData)

                        }
                    })
                }
            },
            //打开本地图片（暖场图）
            openLocalGallery() {
                if(!this.isEnd){
                    this.$refs.localCropper.openDialog()
                }
            },
            //打开素材库（暖场图）
            openSystemGallery() {
                this.$refs.systemCropper.openDialog()
            },
            //上传图片后展示
            editImage (file) {
                this.timestamp = new Date().getTime()
                this.logoPic = file;
                this.liveData.logourl=file.furl
                this.liveData.logoattrid=file.key
            },
            // 图文详情
            getMsgContent(content) {
                this.liveData.content = content
            },
            // 打开图片素材库选择框（封面）
            // openCoverScrollBox() {
            //     this.$refs.coverScrollBox.openDialog()
            // },
            // // 设置素材库选择的图片信息（封面）
            // setMaterialCoverfile(file) {
            //     this.logoPic = file
            //     this.$refs.logofile.setImage(this.logoPic.furl)
            //     this.liveData.logourl = file.furl
            //     this.liveData.logoattrid = file.key
            // },
            // //上传头像
            // setLogourl(file) {
            //     console.log(file)
            //     this.logoPic = file
            //     this.liveData.logourl = file.furl
            //     this.liveData.logoattrid = file.key
            // },
            //加粉二维码
            setLogoFile(file) {
                this.fansCode = file;
                this.liveData.fansguideimgurl = file.furl
            },
            //添加主播
            anchorAdd(){
                this.$refs.addAnchor.open(this.liveData.liveid?this.liveData.liveid:'');
            },
            //发布日期格式化
            getTime() {
                var d=new Date()
                var min=d.getMinutes() // 获取分钟
                d.setMinutes(min+10)
                var year=d.getFullYear()
                var month=change(d.getMonth()+1)
                var day=change(d.getDate())
                var hour=change(d.getHours())
                var minute=change(d.getMinutes())
                var second=change(d.getSeconds())
                function change(t){
                    if(t<10){
                        return "0"+t
                    }else{
                        return t
                    }
                }
                var time = year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second
                this.liveData.begintime=time
            },
            //取消
            cancel(){
              this.$router.go(-1)
            },
            ...mapActions([
                'setLoading'
            ]),
        },
        components: {
            UEditor,LocalCropper,SystemCropper,Upload,ScrollBox,PaySet,AddAnchor,LiveHeadList,CreatSuccess
        },
        computed: {
            ...mapGetters([
                'loading',
                'user',
                'permission'
            ])
        }
    }
</script>
<style lang="scss">
    @import "~common/scss/variable";
    @import "~common/scss/mixin";
    @import "~common/scss/base";
    .liveEdit{
        .liveForm{
            .modeTips{
                margin-bottom: 10px;
                color: #F56C6C;
            }
            .el-radio-group{
                display: flex;
                flex-direction: column;
                .el-radio{
                    margin-bottom: 20px;
                }
                .tips{
                    color: #999;
                    font-size: 13px;
                }
            }
            .magin20{
                padding-left: 20px;
            }
            .position_wrap{
                position: relative;
                z-index: 999;
            }
            .position_box{
                position: absolute;
            }
            .headImage .avatar-uploader{
                box-sizing: border-box;
                width: 320px;
                height: 180px;
            }
            .fansImg .avatar-uploader,.fansImg img{
                box-sizing: border-box;
                width: 100px;
                height: 100px;
            }
            .el-upload__tip{
                color: $tcolor-lightgrey;
                align-self: flex-end;
                margin-left: 20px;
                flex-grow: 1;
            }
            .liveName,.upload-image{
                .el-form-item__content{
                    width: 750px;
                    @include flexBox(flex-start);
                }
            }
            .el-radio__input.is-checked+.el-radio__label{
                color: #303133;
            }
            .liveform_flex{
                display: flex;
                width: 670px;
                justify-content: space-between;
                .el-form-item{
                    width: 300px;
                }
            }
            .fansBox{
                padding-left: 110px;
                .el-input,.el-textarea{
                    width: 450px;
                }
                .flex_fans{
                    .el-form-item__content{
                        display: flex;
                        align-items: flex-end;
                        .fans_tips{
                            color: #999;
                            margin-left: 20px;
                        }
                    }
                }
            }
            .paySet{
                width: 750px;
                background: #F5F7FA;
                padding: 15px 24px;
                .el-radio-group{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .el-radio{
                        margin-bottom: 0;
                    }
                }
                .priceBox,.projectPrice{
                    display:flex;
                    .el-input{
                        width: 230px;
                    }
                    span{
                        margin-left: 14px;
                    }
                }
                .priceBox{
                    display: flex;
                    margin: 10px 0 0 0;
                    .el-form-item__label{
                        text-align: left;
                    }
                    .el-form-item__label::after{
                        content: "*";
                        color: #F56C6C;
                        margin-left: 4px;
                    }
                    .el-form-item__content{
                        margin: 0!important;
                    }
                }
            }
        }
        /*星号显示在右侧*/
        .el-form-item {
            .el-form-item__label {
                text-align: left
            }
            &.is-required {
                .el-form-item__label::after{
                    content: "*";
                    color: #F56C6C;
                    margin-left: 4px;
                }
                .el-form-item__label::before {
                    display: none;
                }
            }
        }
    }
</style>
